import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const { sky, carbon } = colorsPalettes;

export const Wrapper = styled(Flex)`
    padding: 8px 8px 3px 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    background: ${carbon[0]};
`;

export const Container = styled(Flex)`
    padding: 16px 20px;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 8px;
    align-self: stretch;
    border-radius: 0 0 3px 3px;
    background: ${sky[100]};
`;

export const Title = styled(Flex)`
    overflow: hidden;
    text-overflow: ellipsis;

    align-items: end;
    gap: 4px;
    ${setFontVariant("subtitle2", carbon[500])};
`;
export const Text = styled(Flex)`
    overflow: hidden;
    text-overflow: ellipsis;

    ${setFontVariant("input2", carbon[400])};
`;
